// ────────────────────────────────────────────────────────────────────────
// PARRAINAGE EXPOSANT (stand → stand)
//   Code perso `STAND-XXXXXX` — cumulable jusqu'à 50€ de crédit compte.
//   Distinct du parrainage promoteur (`affiliateCode` / `PROM-…`).
// ────────────────────────────────────────────────────────────────────────

const CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // sans I,O,0,1 (lisibilité)

/** Génère un code de parrainage exposant unique-ish : STAND-XXXXXX (6 chars). */
export function generateStandReferralCode(): string {
  let suffix = '';
  const bytes = new Uint32Array(6);
  (globalThis.crypto || (window as any).crypto).getRandomValues(bytes);
  for (let i = 0; i < 6; i++) {
    suffix += CODE_ALPHABET[bytes[i] % CODE_ALPHABET.length];
  }
  return `STAND-${suffix}`;
}

/** Reconnaît un code de parrainage exposant. */
export function isStandReferralCode(code: string | null | undefined): boolean {
  return typeof code === 'string' && /^STAND-[A-Z0-9]{4,10}$/.test(code.trim());
}

/** Construit le lien de partage complet à partir d'un code. */
export function buildReferralLink(code: string): string {
  const origin =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : 'https://festin.live';
  return `${origin}/?ref=${encodeURIComponent(code)}`;
}

// Plafond de crédit parrain (€) — miroir de la logique serveur.
export const REFERRAL_CREDIT_CAP = 50;
// Récompense par filleul confirmé (€).
export const REFERRAL_CREDIT_PER_FILLEUL = 10;
// Réduction de bienvenue filleul (€, une seule fois).
export const REFERRAL_WELCOME_DISCOUNT = 10;
